import { LineImageAlt } from '@qr-front/icons/line-image-alt'
import { fieldLabelCls } from '@qr-front/ui/components/InputField'
import { FileUploadToMediaStorage } from 'components/FileUploadToMediaStorage'
import { useTranslations } from 'next-intl'
import { TUploadedMedia } from 'services/mediaStorage'

const MAX_FILE_SIZE = 5 * 1024 * 1024
const RESOLUTION_LIMIT = { width: 2048, height: 1161 }
const ASPECT_RATIO = 120 / 68

type TImageUpload = {
	initialFileList: File[] | null
	onUpload: (
		uploadedFile: TUploadedMedia,
		originalFile: File,
		index: number,
	) => void
	onUploadStart?: (file: File, index: number) => void
	onDelete: (file: File, index: number) => void
	aspect?: number
}

export const ImageUpload = ({
	initialFileList,
	onUpload,
	onUploadStart,
	onDelete,
	aspect = ASPECT_RATIO,
}: TImageUpload) => {
	const t = useTranslations()

	const fileUploadTranslations = {
		title: t(
			'generator__content_form_section__about__personal_section__upload_image',
		),
		caption: t(
			'generator__content_form_section__about__personal_section__max_image_size',
			{ size: MAX_FILE_SIZE / 1024 / 1024 },
		),
		deleteButtonLabel: t('ui__file_upload__delete_button'),
		unsupportedFormatErrorMessage: t(
			'ui__file_upload__unsupported_format_error',
		),
		sizeTooLargeErrorMessage: t('ui__file_upload__file_size_error', {
			maxSize: MAX_FILE_SIZE / 1024 / 1024,
		}),
	}

	const cropDialogTranslations = {
		zoom: t('ui__image_crop_dialog__zoom'),
		closeButton: t('ui__popup__close_button'),
		saveButton: t('ui__image_crop_dialog__save_button'),
	}

	return (
		<div className="flex w-full flex-col">
			<label className={fieldLabelCls}>
				{t('generator__content_form_section__menu_screen__image')}
			</label>
			<FileUploadToMediaStorage
				uploadPurpose="content_image"
				showCropDialog
				placeholderIcon={<LineImageAlt />}
				initialFileList={initialFileList || []}
				maxFileSize={MAX_FILE_SIZE}
				translations={fileUploadTranslations}
				cropDialogTranslations={cropDialogTranslations}
				resizeResolution={RESOLUTION_LIMIT}
				onUploadStart={onUploadStart}
				onUploadComplete={onUpload}
				onDelete={onDelete}
				aspect={aspect}
			/>
		</div>
	)
}
